export const GLOBAL_STATE = 'State'

export const STATE = 'STATE' as const
export const STATE_CREATE = 'STATE_CREATE' as const
export const STATE_DELETE = 'STATE_DELETE' as const
export const STATE_LIST = 'STATE_LIST' as const
export const STATE_ALL = 'STATE_ALL' as const
